module.exports = __webpack_public_path__ + "static/media/info_clear_1.e15ca0cf.jpg";